// extracted by mini-css-extract-plugin
module.exports = {"dataRow":"styles_dataRow__3Gk42","dataColunmTitle":"styles_dataColunmTitle__3ffTT","dataColunmInfo":"styles_dataColunmInfo__280cH","nenhumDado":"styles_nenhumDado__1FaLm"};